import { getDataIdsFromContract } from '../../../core/utils/generateDataId';

export const ACCOUNT_MANAGER_CONTACT_DIALOG_DATA_IDS = getDataIdsFromContract({
  base: 'account-manager-contact-dialog',
  contactList: 'contact-list',
  emptyList: 'empty-list',
  emptyListTitle: 'empty-list-title',
  fallbackEmail: 'fallback-email',
  fallbackButton: 'fallback-button',
  getContactButton: (email: string) => `contact-button-${email}`,
  getContactEmail: (email: string) => `contact-email-${email}`
});
